module.exports = __webpack_public_path__ + "static/img/8.25d4bd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/8.png
// module id = maFO
// module chunks = 0